import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initAppTimezone } from "./lib/appTime";

initAppTimezone(window.__BACKEND_URL__ || process.env.REACT_APP_BACKEND_URL || "");
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
